import styled from "styled-components";
export const LoaderContainer = styled.span.withConfig({
  displayName: "loaderstyles__LoaderContainer",
  componentId: "sc-1g7ftxy-0"
})(["color:", ";position:relative;", ""], ({
  color
}) => color, {
  display: "inline-flex",
  alignItems: "center"
});
